import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { sendCustomerInvitation } from '../thunks/customers';
import {
  cancelInvitationById,
  getMembersInvitationsByCustomerId,
} from '../thunks/invitations';

const invitationsAdapter = createEntityAdapter();

const INITIAL_STATE = invitationsAdapter.getInitialState({
  currentInvitation: {},
});

export const invitationsSlice = createSlice({
  name: 'invitations',
  initialState: INITIAL_STATE,
  reducers: {
    setInvitations: (state, action) => {
      invitationsAdapter.upsertMany(state, action.payload);
    },
    resetInvitations: () => INITIAL_STATE,
    // TODO: esta es la invitacion si estamos logueandonos de un link
    setEmailedInvitation: (state, action) => {
      state.currentInvitation = action.payload;
    },
    removeEmailedInvitation: (state) => {
      state.currentInvitation = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMembersInvitationsByCustomerId.fulfilled, (state, action) => {
        invitationsAdapter.upsertMany(state, action.payload);
      })
      .addCase(sendCustomerInvitation.fulfilled, (state, action) => {
        invitationsAdapter.upsertOne(state, action.payload);
      })
      .addCase(cancelInvitationById.fulfilled, (state, action) => {
        invitationsAdapter.removeOne(state, action.meta.arg.invitationId);
      });
  },
});

export const {
  setInvitations,
  resetInvitations,
  setEmailedInvitation,
  removeEmailedInvitation,
} = invitationsSlice.actions;

export const invitationsAdapterSelectors = invitationsAdapter.getSelectors(
  (state) => state.invitations
);

export default invitationsSlice.reducer;
